module.exports = __webpack_public_path__ + "img/inter-2.8d0aff63.jpg";